import './Manage.scss';

import { CreateTag } from './Create';
import { EditTags } from './EditTags';
import React from 'react';
import { ViewArea } from '@ui/general';

export const ManageTagsView: React.FC = () =>
	<ViewArea
		direction='vertical'
		fullWidth
		id='manage-tags'>
		<CreateTag />
		<EditTags />
	</ViewArea>;

